import { styled, useTheme, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BlockContainer } from '../../features/landingMain/BlockContainer';
import { colors } from '../../plugins/material-ui/themes/onvistaTheme';

const Line = styled('div')({
  height: '10px',
  background: colors.corp400,
});

const SubFooter = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2),
  [theme.breakpoints.only('xs')]: {
    marginTop: theme.spacing(1),
  },
  display: 'flex',
  justifyContent: 'flex-start',
  flexWrap: 'wrap',
  '& > :not(style)': {
    marginRight: theme.spacing(5),
  },
}));

const GreyLink = styled(Link)(({ theme }) => ({
  color: theme.palette.text.disabled,
  fontSize: '12px',
}));

const Copyright = styled('span')(({ theme }) => ({
  color: theme.palette.text.disabled,
  fontSize: '12px',
}));

export const Footer = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const subFooterItems = t('footer.subFooterItems', {
    returnObjects: true,
  }) as {
    href: string;
    title: string;
  }[];
  return (
    <>
      <Line />
      <BlockContainer backgroundColor={theme.palette.secondary.main}>
        <SubFooter>
          <Copyright>© {currentYear} onvista Cashback by Rentablo</Copyright>
          {subFooterItems.map(({ href, title }, index) => (
            <GreyLink href={href} key={index}>
              {title}
            </GreyLink>
          ))}
        </SubFooter>
      </BlockContainer>
    </>
  );
};
